import * as ng from 'angular';
import * as Linq from 'linq-es5';
import * as UrlPattern from 'url-pattern';
import * as Core from './interfaces';

//let SiteConfigServiceFactory: Function = ($q: ng.IQService,
//    $injector: ng.auto.IInjectorService) => {
//    return new SiteConfigService($q, $injector);
//}

//SiteConfigServiceFactory



interface ISiteConfigService {
    getResourceUri(serviceName: string): string;
    getClientAuthCode(id: string): string;
    getConfig(): any;
    getConfigAsync(): ng.IPromise<Core.IConfig>;
    getClientByType(clientType): Core.IClient;
    getClientById(id): any;
    getUriMatch(uri): any;

};

export class SiteConfigService implements ISiteConfigService {
    public static $inject: Array<string> = ['$q', '$injector'];

    private cachedConfig: Core.IConfig = null;
    private retrieving: Boolean = false;
    private waitingPromises: Array<ng.IDeferred<any>> = [];
    private initInjector: ng.auto.IInjectorService = ng.injector(['ng']);
    private $http: ng.IHttpService = this.initInjector.get('$http');
    private options: any = {
        segmentNameCharset: 'a-zA-Z0-9_-'
    };
    private uriPattern: UrlPattern;

    constructor(private $q: ng.IQService,
        private $injector: ng.auto.IInjectorService) {

        this.uriPattern = new UrlPattern('(*)/api(/ref)/:resource(/:id)(/:child)(/:subId)', this.options);
        this.loadConfig();

    }

    private primaryConfigLoadPromise: ng.IPromise<any> = null;

    loadConfig(): ng.IPromise<any> {

        if (this.primaryConfigLoadPromise)
            return this.primaryConfigLoadPromise;

        this.primaryConfigLoadPromise = this.$http.get('site.json')
            .then((response: any) => {
                if (!(response.data && response.data.config)) {
                    console.log('Failed to load site.json');
                    return this.$q.reject(null);
                }

                this.cachedConfig = response.data.config;
                this.indexServices(this.cachedConfig);
                console.log('site.json Loaded');
                return this.$q.resolve(this.cachedConfig);
            })
            .catch((err) => {
                console.log('Failed to load site.json');
                return this.$q.reject(null);
            });

        return this.primaryConfigLoadPromise;
    };

    private getServiceUriArray(service) {
        return Linq.From(Object.keys(service.api))
            .Select((key: any) => {

                var x = {
                    key: key,
                    value: service.api[key]
                } as any;

                var fullUri = service.baseUri + x.value.relativeUri;
                return {
                    key: x.key.trim().toLowerCase(),
                    uri: fullUri,
                    baseUri: service.baseUri.trim().toLowerCase(),
                    relativeUri: x.value.relativeUri.trim().toLowerCase(),
                    resource: x.value.resource ? x.value.resource.trim().toLowerCase() : '',
                    clientId: x.value.clientId,
                    scope: service.scope
                };
            }).ToArray();
    };

    private indexServices(config): void {

        var uriEnum = Linq.From(this.getServiceUriArray(config.services.asm).concat(
            this.getServiceUriArray(config.services.iam),
            this.getServiceUriArray(config.services.sts)
        ));

        var uriDict = uriEnum
            .ToDictionary(
            (x: any) => { return x.key; },
            (x: any) => { return x.uri; }
            );

        config.clientDict = Linq.From(this.cachedConfig.clients)
            .ToDictionary(
            (x: any) => { return x.id; },
            (x: any) => { return x; }
            );

        config.resourceUriDict = uriDict;
        config.uriEnumerable = uriEnum;
    };

    public getResourceUri(serviceName: string): string {
        if (this.cachedConfig !== null) {
            return this.cachedConfig.resourceUriDict.get(serviceName.toLowerCase());
        }

        console.error('getResourceUri(serviceName) failed for serviceName=' + serviceName + '.');
    };

    public getClientAuthCode(id: string): string {
        if (this.cachedConfig) {
            var client = this.cachedConfig.clientDict.get(id);
            return btoa(client.clientId + ':' + client.secret);
        }

        return null;
    };

    public getConfig(): Core.IConfig {
        return this.cachedConfig;
    };

    public getConfigAsync(): ng.IPromise<any> {

        if (this.cachedConfig !== null) {
            //setTimeout(() => {
            return this.$q.resolve(this.cachedConfig);
            //}, 1);
        }
        else {
            return this.loadConfig().then(() => {
                return this.$q.resolve(this.cachedConfig);
            });
        }
    };

    public getClientByType(clientType): Core.IClient {
        var config = this.getConfig();
        return Linq.From(config.clients)
            .FirstOrDefault((x: any) => {
                return x.type === clientType.toLowerCase();
            });
    };

    public getClientById(id): any {
        var config = this.getConfig();
        return Linq.From(config.clients)
            .FirstOrDefault((x: any) => {
                return x.id === id;
            });
    };

    public getUriMatch(uri): any {

        if (uri === undefined) {
            console.error("getUriMatch(uri) failed for uri=undefined.");
            return null;
        }

        uri = uri.trim();

        if (!this.cachedConfig) {
            console.error("getUriMatch(uri) failed since cachedConfig is undefined.");
            return null;
        }

        var parts = this.uriPattern.match(uri);
        if (!parts) {
            // Logging this case result in number of unnecessary logs when there is nothing wrong.
            return null;
        }

        parts.baseUri = parts._ ? parts._.trim().toLowerCase() : '';

        if (parts.resource)
            parts.resource = parts.resource.trim().toLowerCase();

        if (parts.child)
            parts.child = parts.child.trim().toLowerCase();

        if (parts.resource) {
            var baseMatches = Linq.From(this.cachedConfig.uriEnumerable.where((x) => {
                // No need to call toLowerCase(x.baseUri) since x.baseUri was converted to lower case
                // when the object is created.
                return (parts.baseUri && x.baseUri === parts.baseUri || !parts.baseUri);
            }).toArray());

            if (!baseMatches.Count()) {
                console.error('getUriMatch(uri) failed for uri=' + uri + '. Reason: mo matches found for baseUri=' + parts.baseUri + '.');
                return null;
            }

            if (parts.child) {
                var childMatch = baseMatches.FirstOrDefault((x: any) => {
                    return x.resource && parts.child === x.resource;
                });

                if (childMatch)
                    return childMatch;
            }

            var baseResourceMatch = baseMatches.FirstOrDefault((x: any) => {
                return (parts.resource === x.resource);
            });

            if (baseResourceMatch)
                return baseResourceMatch;

            console.error('getUriMatch(uri) failed for uri=' + uri + '. Reason: no resource exists in site.config file matching resource=' + parts.resource + '.');
            return null;
        }
        else {
            console.error('getUriMatch(uri) failed for uri=' + uri + '. Reason: the resource part of the uri is undefined.');
            return null;
        }
    };
}

let SiteConfig = {
    name: "SiteConfig",
    factory: ['$q', '$injector', SiteConfigService]
};

export { SiteConfig, ISiteConfigService };
export default SiteConfig;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/core/site-config.ts